const STORAGE_KEY = "pocr.googleLeadAttribution";
const MAX_AGE_MS = 90 * 24 * 60 * 60 * 1000;
let pending = null;

function clean(value, maxLength) {
  return value && value.length <= maxLength && /^[a-zA-Z0-9_-]+$/.test(value)
    ? value : undefined;
}

function consentGranted(preferences) {
  if (preferences?.purposes) return preferences.purposes["5"] === true;
  return preferences?.consent === true;
}

function preferencesNow() {
  try { return window._iub?.cs?.api?.getPreferences(); }
  catch { return undefined; }
}

function sync(preferences) {
  if (!preferences) return;
  try {
    if (!consentGranted(preferences)) {
      window.sessionStorage.removeItem(STORAGE_KEY);
      return;
    }
    if (pending) window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(pending));
  } catch {
    // Storage restrictions must never prevent registration.
  }
}

export function initializeGoogleLeadAttribution() {
  const params = new URLSearchParams(window.location.search);
  const gclid = clean(params.get("gclid"), 255);
  if (gclid) {
    pending = {
      gclid,
      googleCampaignId: clean(params.get("campaignid") || params.get("campaign_id"), 100),
      googleCreativeId: clean(params.get("creative") || params.get("creativeid") || params.get("creative_id"), 100),
      capturedAt: Date.now(),
    };
  }
  sync(preferencesNow());
  window.addEventListener("pocr:cookie-preferences", event => sync(event.detail));
}

export function getGoogleLeadAttribution() {
  const preferences = preferencesNow();
  sync(preferences);
  if (!consentGranted(preferences)) return {};
  let attribution = pending;
  try {
    attribution = attribution || JSON.parse(window.sessionStorage.getItem(STORAGE_KEY));
  } catch { /* Fall back to the current visit when storage is unavailable. */ }
  if (!attribution || !Number.isFinite(attribution.capturedAt)
      || attribution.capturedAt > Date.now()
      || Date.now() - attribution.capturedAt > MAX_AGE_MS) return {};
  const gclid = clean(attribution.gclid, 255);
  if (!gclid) return {};
  return {
    gclid,
    googleCampaignId: clean(attribution.googleCampaignId, 100),
    googleCreativeId: clean(attribution.googleCreativeId, 100),
    googleAttributionConsent: true,
  };
}
